import { cx } from '@emotion/css';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { styled } from '@mui/material';
import { DataGridPro as MUIGrid } from '@mui/x-data-grid-pro';
import React, { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { NoDataOverlay } from '../NoDataOverlay/NoDataOverlay';
import { DataGridStyles } from './DataGrid.styles';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZES, DESCEND_FIRST_SORTING_ORDER, DataMode, HEADER_HEIGHT, ROW_HEIGHT, SCROLLBAR_SIZE, } from './constants';
const StyledGrid = styled(MUIGrid)(DataGridStyles.StyledComponent);
export const DataGrid = (props) => {
    const { className, rows, loading, mode = DataMode.CLIENT, pagination, onPaginationChange, sort, onSortChange, getRowId, pageSizes = DEFAULT_PAGE_SIZES, init, components, getRowClassName, } = props;
    const columns = useMemo(() => {
        return props.columns.map((column) => {
            if (column.type === 'metric') {
                return Object.assign(Object.assign({}, column), { type: 'number', sortingOrder: column.sortingOrder || [...DESCEND_FIRST_SORTING_ORDER] });
            }
            return column;
        });
    }, [props.columns]);
    const rowCount = mode === DataMode.SERVER ? props.rowCount : undefined;
    const initState = {
        pagination: {
            paginationModel: Object.assign({ pageSize: DEFAULT_PAGE_SIZE }, init === null || init === void 0 ? void 0 : init.pagination),
        },
        sorting: { sortModel: (init === null || init === void 0 ? void 0 : init.sort) ? [init.sort] : [] },
    };
    const sortModal = sort ? [sort] : undefined;
    return (React.createElement(StyledGrid, { initialState: initState, className: cx(className), loading: loading, rowCount: rowCount, pagination: true, autoHeight: (rows === null || rows === void 0 ? void 0 : rows.length) > 0, columnHeaderHeight: HEADER_HEIGHT, scrollbarSize: SCROLLBAR_SIZE, pageSizeOptions: pageSizes, paginationMode: mode, paginationModel: pagination, onPaginationModelChange: (model) => {
            onPaginationChange === null || onPaginationChange === void 0 ? void 0 : onPaginationChange(model);
        }, disableRowSelectionOnClick: true, rows: rows, getRowId: getRowId ? getRowId : (row) => row.id || uuidv4(), rowHeight: ROW_HEIGHT, slots: Object.assign({ columnSortedAscendingIcon: ArrowDropUpIcon, columnSortedDescendingIcon: ArrowDropDownIcon, noRowsOverlay: NoDataOverlay, noResultsOverlay: NoDataOverlay }, components), columns: columns, sortingMode: mode, sortModel: sortModal, onSortModelChange: (model) => {
            onSortChange === null || onSortChange === void 0 ? void 0 : onSortChange(model[0]);
        }, getRowClassName: getRowClassName }));
};
//# sourceMappingURL=DataGrid.js.map